// extracted by mini-css-extract-plugin
module.exports = {"templateCard":"TemplateCard_templateCard__32Tcg","title":"TemplateCard_title__vs19f","image":"TemplateCard_image__2RcNO","desc":"TemplateCard_desc__1z683"};